import React from 'react';
import { mockData } from '../utils/mock';

const FounderSection = () => {
  return (
    <section className="founder-section section-container">
      <div className="section-header">
        <h2 className="section-title">Nacido desde el arco</h2>
      </div>

      <div className="founder-grid">
        <div className="founder-story">
          <h3 className="founder-name">Edgar Merino fue arquero.</h3>
          
          <div className="founder-experience">
            <p>Jugó en tercera división en Chile.</p>
            <p>Fue parte de la selección chilena de futsal.</p>
          </div>

          <p className="founder-text">Vivió el arco desde dentro.</p>
          <p className="founder-text">La presión.</p>
          <p className="founder-text">El silencio.</p>
          <p className="founder-text">El error que nadie olvida.</p>

          <div className="founder-clients">
            <h4>Después, desde la representación, acompañó procesos reales de crecimiento internacional:</h4>
            <ul className="clients-list">
              <li>Christiane Endler</li>
              <li>Antonia Canales</li>
              <li>Emily Burns</li>
              <li>Nayluisa Cáceres</li>
              <li>Christian Bravo (Huachipato)</li>
              <li>José Sánchez (Atlético de Madrid)</li>
            </ul>
          </div>

          <div className="founder-insight">
            <p className="highlight">El número 1 necesita una estructura diseñada para el número 1.</p>
          </div>
        </div>

        <div className="founder-keepers">
          <div className="keepers-grid">
            {mockData.keepers.slice(0, 4).map((keeper) => (
              <div key={keeper.id} className="keeper-card-small">
                <img src={keeper.image} alt={keeper.name} />
                <div className="keeper-info-small">
                  <p className="keeper-name-small">{keeper.name}</p>
                  <p className="keeper-club-small">{keeper.club}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;
